import React, { useState, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import {
  addComments,
  getAllComments,
  deleteComments,
} from "../../../../api/ApiConfig";
import "./comments.css";
import toast from "react-hot-toast";
import { FaRegFolderOpen } from "react-icons/fa";

const PredefinedComments = () => {
  const [commentsList, setCommentsList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ comments: "", type: "" });
  const [refreshKey, setRefreshKey] = useState(0);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedCommentId, setSelectedCommentId] = useState(null);

  // Fetch all comments when the component mounts or refreshKey changes
  useEffect(() => {
    const fetchComments = async () => {
      try {
        const response = await getAllComments();
        setCommentsList(response.data);
      } catch (error) {
        console.error("Error fetching comments:", error);
        toast.error("Failed to load comments");
      }
    };

    fetchComments();
  }, [refreshKey]);

  const handleAddClick = () => {
    setFormData({ comments: "", type: "" });
    setShowModal(true);
  };

  const handleAddComment = async (e) => {
    e.preventDefault();
    try {
      await addComments(formData);
      toast.success("Comment added successfully!");
      setFormData({ comments: "", type: "" });
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      console.error("Error adding comment:", error);
      toast.error("Failed to add comment");
      setShowModal(false);
    }
  };

  const handleDeleteClick = (commentId) => {
    setSelectedCommentId(commentId);
    setShowConfirmModal(true);
  };

  const confirmDelete = async () => {
    try {
      const userData = { comment_id: selectedCommentId };
      await deleteComments(userData);
      toast.success("Comment deleted successfully!");
      setShowConfirmModal(false);
      setSelectedCommentId(null);
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      console.error("Error deleting comment:", error);
      toast.error("Failed to delete comment");
      setShowConfirmModal(false);
    }
  };

  const cancelDelete = () => {
    setShowConfirmModal(false);
    setSelectedCommentId(null);
  };

  return (
    <div className="comments-container">
      <h2 className="comments-heading">Predefined Comments</h2>
      <button className="comments-add-btn" onClick={handleAddClick}>
        Add Comment
      </button>

      <div className="comments-table-wrapper" style={{ height: "60vh", overflow: "auto" }}>
        <table className="comments-table mt-2">
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Comment</th>
              <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="comments-scroll-body">
            {commentsList.length === 0 ? (
              <tr>
                <td colSpan="4">
                  <div className="no-posts">
                    <div className="no-posts-icon">
                      <FaRegFolderOpen />
                    </div>
                    <p>No Posts Available</p>
                  </div>
                </td>
              </tr>
            ) : (
              commentsList.map((item, idx) => (
                <tr key={item._id || idx}>
                  <td>{idx + 1}</td>
                  <td>{item.comments}</td>
                  <td>{item.type}</td>
                  <td>
                    <button
                      className="comments-action-btn comments-delete-btn"
                      onClick={() => handleDeleteClick(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Add Modal */}
      {showModal && (
        <div className="comments-modal-overlay">
          <div className="comments-modal">
            <button
              className="comments-modal-close-btn"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            >
              <AiOutlineClose size={20} />
            </button>

            <h3 className="comments-modal-title">Add Predefined Comment</h3>
            <form className="comments-modal-form" onSubmit={handleAddComment}>
              <div className="comments-form-group">
                <label className="comments-form-label">
                  Comment:
                  <textarea
                    className="comments-textarea"
                    required
                    value={formData.comments}
                    onChange={(e) =>
                      setFormData({ ...formData, comments: e.target.value })
                    }
                    rows={4}
                  />
                </label>
              </div>
              <div className="comments-form-group">
                <label className="comments-form-label">
                  Type:
                  <select
                    className="comments-select"
                    required
                    value={formData.type}
                    onChange={(e) =>
                      setFormData({ ...formData, type: e.target.value })
                    }
                  >
                    <option value="">Select Comment type</option>
                    <option value="new_wins">New Win</option>
                    <option value="events">Events</option>
                    <option value="news">News</option>
                    <option value="appreciations">Appreciation</option>
                    <option value="announcements">Announcement</option>
                    <option value="wish">Wish</option>
                    <option value="others">Others</option>
                  </select>
                </label>
              </div>
              <div className="comments-modal-actions">
                <button type="submit" className="comments-modal-save-btn">
                  Save Comment
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showConfirmModal && (
        <div className="comments-modal-overlay">
          <div className="comments-modal">
            <h3 className="comments-modal-title">Confirm Delete</h3>
            <p>Are you sure you want to delete this comment?</p>
            <div className="comments-modal-actions">
              <button className="comments-modal-save-btn" onClick={confirmDelete}>
                Yes
              </button>
              <button className="comments-modal-save-btn" style={{backgroundColor: "#fde6e6", color: "#d63333", border: "1px solid #f5b9b9"}} onClick={cancelDelete}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PredefinedComments;
